export const ENV = {
  apiBaseUrl:
    import.meta.env?.MODE === "development"
      ? "http://localhost:6003"
      : `https://api.legacy-bob.${import.meta.env?.VITE_ZONENAME}`,
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID,
  mainframeTokenIssuerUrl: import.meta.env.VITE_MAINFRAME_TOKEN_ISSUER_URL,
};
